import { render, staticRenderFns } from "./searchCommunityDataList.vue?vue&type=template&id=b44093d6&scoped=true"
import script from "./searchCommunityDataList.vue?vue&type=script&lang=js"
export * from "./searchCommunityDataList.vue?vue&type=script&lang=js"
import style0 from "./searchCommunityDataList.vue?vue&type=style&index=0&id=b44093d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44093d6",
  null
  
)

export default component.exports